// tslint:disable
export var PharmacyType;
(function (PharmacyType) {
    // OTH
    PharmacyType[PharmacyType["OTHER"] = 0] = "OTHER";
    // RTL
    PharmacyType[PharmacyType["RETAIL"] = 1] = "RETAIL";
    // LAB
    PharmacyType[PharmacyType["LABORATORY"] = 2] = "LABORATORY";
    // HOS
    PharmacyType[PharmacyType["HOSPITAL"] = 3] = "HOSPITAL";
    // MCO
    PharmacyType[PharmacyType["MANAGEDCAREORGINIZATION"] = 4] = "MANAGEDCAREORGINIZATION";
    // RET
    PharmacyType[PharmacyType["RESIDENTIALTREATMENT"] = 5] = "RESIDENTIALTREATMENT";
})(PharmacyType || (PharmacyType = {}));
//# sourceMappingURL=PharmacyType.js.map